import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IGameWinnersViewModel } from '@/app-modules/config/models/game-winners-model';
import { IGameWinnersService } from '@/app-modules/game-winners/game-winners-service-interface';
import { ICincoWinnerDetailedViewModel, IIndividualGameWinnerViewModel } from '@/app-modules/config/models/game-winners-detailed-model';

@Component({
  name: 'CincoWinnersWinnersComponent'
})
export default class CincoWinnersWinnersComponent extends TombolaBaseComponent {
  @Prop() public gameName: string;
  private gameWinnersResults: IGameWinnersViewModel[];
  private previousGameWinners: ICincoWinnerDetailedViewModel[] = [];
  private previousJackpotGameWinners: ICincoWinnerDetailedViewModel[] = [];
  private sixtySecondWinnersUpdate: number = 0;
  private isLoading: boolean = false;

  private get gamesWinnersService(): IGameWinnersService {
    return this.$container.get(SERVICE_IDENTIFIERS.IGameWinnersService) as IGameWinnersService;
  }

  private async mounted() {
    this.getAndUpdateWinners();
    this.sixtySecondWinnersUpdate = window.setInterval(async () => await this.getAndUpdateWinners(), 60000);
  }

  private beforeDestroy() {
    window.clearInterval(this.sixtySecondWinnersUpdate);
  }

  private async getAndUpdateWinners() {
    try {
      this.isLoading = true;
      this.gameWinnersResults = await this.gamesWinnersService.getGameWinners(this.gameName);
      this.previousGameWinners = this.getPrevious10GameWinners(this.gameWinnersResults);
      this.previousJackpotGameWinners = this.getPrevious10JackpotGameWinners(this.gameWinnersResults);
    }
    finally {
      this.isLoading = false;
    }
  }

  private getPrevious10GameWinners(gameWinnersResults: IGameWinnersViewModel[]): ICincoWinnerDetailedViewModel[] {
    const winnersList = new Array<ICincoWinnerDetailedViewModel>();
    gameWinnersResults.map((gameWinner) => {
      gameWinner.gameWinners.map((winner) => {
        const cincoWinner: ICincoWinnerDetailedViewModel = {
          gameId: winner.gameId,
          stamp: winner.stamp,
          formattedStamp: winner.formattedStamp,
          winners: winner.winners,
          isLinkGame: winner.isLinkGame,
          isPromoGame: winner.isPromoGame,
          gameEngineType: winner.gameEngineType,
          roomName: gameWinner.roomName
        };
        winnersList.push(cincoWinner);
      });
    });

    return winnersList.sort((a: ICincoWinnerDetailedViewModel, b: ICincoWinnerDetailedViewModel) => {
      return this.SortDateDescending(a.stamp, b.stamp);
    }).slice(0, 10);
  }

  private getPrevious10JackpotGameWinners(gameWinnersResults: IGameWinnersViewModel[]): ICincoWinnerDetailedViewModel[] {
    const winnersList = new Array<ICincoWinnerDetailedViewModel>();
    gameWinnersResults.map((gameWinner) => {
      gameWinner.jackpotWinners.map((winner) => {
        const cincoWinner: ICincoWinnerDetailedViewModel = {
          gameId: winner.gameId,
          stamp: winner.stamp,
          formattedStamp: winner.formattedStamp,
          winners: winner.winners,
          isLinkGame: winner.isLinkGame,
          isPromoGame: winner.isPromoGame,
          gameEngineType: winner.gameEngineType,
          roomName: gameWinner.roomName
        };
        winnersList.push(cincoWinner);
      });
    });

    return winnersList.sort((a: ICincoWinnerDetailedViewModel, b: ICincoWinnerDetailedViewModel) => {
      return this.SortDateDescending(a.stamp, b.stamp);
    }).slice(0, 10);
  }

  private getWinnerMessageForUser(gameWinner: IIndividualGameWinnerViewModel): string {
    const messageTemplate: string = this.$lang.game.winners.winnerTemplate;
    return messageTemplate.format({
      username: gameWinner.username,
      prize: gameWinner.prize.toFixed(2)
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/_components/cinco-winners/cinco-winners.winners-view.component.ts